module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 1rem 0"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "0 0 10px 0"
    }
  }, [(!_vm.row.fapiao.id) ? _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.fapiaoPickerShow = true
      }
    }
  }, [_vm._v("选择抬头")]) : _vm._e()], 1), _vm._v(" "), _c('van-form', {
    on: {
      "submit": _vm.onSubmitPre,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("确认发票信息")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '发票抬头不能为空'
      }],
      "label": "发票抬头",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入发票抬头"
    },
    model: {
      value: (_vm.row.fapiao_taitou),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_taitou", $$v)
      },
      expression: "row.fapiao_taitou"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '税号不能为空'
      }],
      "label": "税号",
      "border": false,
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入税号"
    },
    model: {
      value: (_vm.row.fapiao_shuihao),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_shuihao", $$v)
      },
      expression: "row.fapiao_shuihao"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("如果您所在的单位没有纳税人识别号请填写“无”")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "地址",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "（非必填）发票购买方地址"
    },
    model: {
      value: (_vm.row.fapiao_address),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_address", $$v)
      },
      expression: "row.fapiao_address"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "电话",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "（非必填）发票购买方电话"
    },
    model: {
      value: (_vm.row.fapiao_tel),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_tel", $$v)
      },
      expression: "row.fapiao_tel"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "开户行及账号",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "（非必填）发票购买方开户行及账号"
    },
    model: {
      value: (_vm.row.fapiao_account),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_account", $$v)
      },
      expression: "row.fapiao_account"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "备注",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.row.fapiao_beizhu),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_beizhu", $$v)
      },
      expression: "row.fapiao_beizhu"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("不会体现在发票上，仅显示给管理员")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.email,
        message: '请输入正确的邮箱'
      }],
      "error-message-align": "right",
      "label": "接收邮箱",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入接收邮箱"
    },
    model: {
      value: (_vm.row.fapiao_email),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_email", $$v)
      },
      expression: "row.fapiao_email"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "接收手机",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入接收手机"
    },
    model: {
      value: (_vm.row.fapiao_phone),
      callback: function($$v) {
        _vm.$set(_vm.row, "fapiao_phone", $$v)
      },
      expression: "row.fapiao_phone"
    }
  }), _vm._v(" "), _c('van-divider', [_vm._v("发票明细单")]), _vm._v(" "), _c('div', {
    staticClass: "fapiao-tip-wrap"
  }, _vm._l((_vm.row.list), function(v, k) {
    return _c('div', {
      key: k
    }, [_vm._v("\n                    " + _vm._s(v.name) + " "), _c('br'), _vm._v(" 单价：" + _vm._s(v.price) + "元 数量：" + _vm._s(v.num) + " "), _c('br'), _vm._v(" "), _c('van-cell', {
      attrs: {
        "title": "小记（元）"
      }
    }, [_c('van-stepper', {
      attrs: {
        "max": v.max,
        "min": 0
      },
      model: {
        value: (v.total),
        callback: function($$v) {
          _vm.$set(v, "total", $$v)
        },
        expression: "v.total"
      }
    })], 1), _vm._v(" "), _c('hr', {
      staticStyle: {
        "background-color": "#ccc",
        "height": "1px",
        "border": "none"
      }
    })], 1)
  }), 0), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.2rem"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem",
      "margin": "10px"
    },
    attrs: {
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "保存中...",
      "native-type": "submit"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("确认发票信息")])], 1)], 1), _vm._v(" "), (_vm.row.fapiao_status == 0) ? _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("申请开票")])], 1) : _vm._e()], 1), _vm._v(" "), (_vm.row.fapiao_status == 2) ? _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.download($event)
      }
    }
  }, [_vm._v("发票下载")])], 1) : _vm._e(), _vm._v(" "), (_vm.row.fapiao_status == 3) ? _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showError()
      }
    }
  }, [_vm._v("开票失败(原因)")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.refresh()
      }
    }
  }, [_vm._v("刷新")])], 1) : _vm._e(), _vm._v(" "), (_vm.row.fapiao_status == 1) ? _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("开票中")])], 1) : _vm._e(), _vm._v(" "), (_vm.row.fapiao_status == -1) ? _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": ""
    }
  }, [_vm._v("管理员开票中")])], 1) : _vm._e(), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "width": "80%",
      "height": "auto",
      "text-align": "center"
    },
    model: {
      value: (_vm.showFapiao),
      callback: function($$v) {
        _vm.showFapiao = $$v
      },
      expression: "showFapiao"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "height": "auto"
    },
    attrs: {
      "src": _vm.fapiaoUrl
    }
  }), _vm._v(" "), (!_vm.isApp) ? _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    }
  }, [_vm._v("请长按图片保存")]) : _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    },
    on: {
      "click": _vm.appDownload
    }
  }, [_vm._v("点击下载")])], 1), _vm._v(" "), _c('van-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('van-loading', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "200px"
    },
    attrs: {
      "type": "spinner"
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  })], 1), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "发票预览",
      "show-cancel-button": ""
    },
    on: {
      "confirm": _vm.onSubmit
    },
    model: {
      value: (_vm.fapiao_show),
      callback: function($$v) {
        _vm.fapiao_show = $$v
      },
      expression: "fapiao_show"
    }
  }, [_c('div', {
    staticClass: "bg-fapiao"
  }, [_c('p', {
    staticClass: "fapiao-title"
  }, [_vm._v("\n                " + _vm._s(_vm.row.fapiao_taitou) + "\n                "), _c('br'), _vm._v("\n                " + _vm._s(_vm.row.fapiao_shuihao)), _c('br'), _vm._v("\n                " + _vm._s(_vm.row.fapiao_address) + " " + _vm._s(_vm.row.fapiao_tel)), _c('br'), _vm._v("\n                " + _vm._s(_vm.row.fapiao_account))]), _vm._v(" "), _c('p', {
    staticClass: "fapiao-goods"
  }, _vm._l((_vm.row.list), function(v, k) {
    return _c('span', {
      key: k
    }, [_vm._v(_vm._s(v.name)), _c('br')])
  }), 0), _c('p', {
    staticClass: "fapiao-count"
  }, _vm._l((_vm.row.list), function(v, k) {
    return _c('span', {
      key: k
    }, [_vm._v(_vm._s(v.num)), _c('br')])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "fapiao-price"
  }, _vm._l((_vm.row.list), function(v, k) {
    return _c('span', {
      key: k
    }, [_vm._v("¥" + _vm._s(v.total)), _c('br')])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "fapiao-rate"
  }, _vm._l((_vm.row.list), function(v, k) {
    return _c('span', {
      key: k
    }, [_vm._v("6%"), _c('br')])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "fapiao-duty"
  }, _vm._l((_vm.row.list), function(v, k) {
    return _c('span', {
      key: k
    }, [_vm._v("¥" + _vm._s(v.total * 0.06)), _c('br')])
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "fapiao-total"
  }, [_vm._v("¥" + _vm._s(_vm.row.order.total))]), _vm._v(" "), _c('p', {
    staticClass: "fapiao-total-cn"
  }, [_vm._v(_vm._s(_vm.row.total_price_cn))])])]), _vm._v(" "), _c('FapiaoPicker', {
    attrs: {
      "show": _vm.fapiaoPickerShow
    },
    on: {
      "onChange": _vm.changeFapiao,
      "onClose": _vm.closeFapiao
    }
  }), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "description": "请选择要下载的发票",
      "actions": _vm.row.fapiao_list,
      "cancel-text": "取消",
      "close-on-click-action": ""
    },
    on: {
      "cancel": _vm.onSheetCancel,
      "select": _vm.onSelect
    },
    model: {
      value: (_vm.sheetActiveShow),
      callback: function($$v) {
        _vm.sheetActiveShow = $$v
      },
      expression: "sheetActiveShow"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e04b063c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFapiao.vue
// module id = 2595
// module chunks = 0